var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A1807A72-CF37-47FB-B9A2-A44DADB8E88B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logged-in---desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D/home_incomplete",
    transform: "translate(-28.000000, -235.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "online-training",
    transform: "translate(28.000000, 233.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/system/book",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,12.25 L14,0.75 C14,0.334375 13.665625,0 13.25,0 L2.5,0 C1.11875,0 0,1.11875 0,2.5 L0,14 C0,15.1046875 0.8953125,16 2,16 L13.625,16 C13.83125,16 14,15.83125 14,15.625 L14,15.375 C14,15.16875 13.83125,15 13.625,15 L13.521875,15 C13.396875,14.36875 13.421875,13.446875 13.534375,12.94375 C13.80625,12.83125 14,12.5625 14,12.25 Z M12.634375,15 L2,15 C1.4478125,15 1,14.5521875 1,14 C1,13.4478125 1.4478125,13 2,13 L12.634375,13 C12.54375,13.5875 12.5375,14.3625 12.634375,15 Z M13,12 L2,12 C1.63375,12 1.2953125,12.105625 1,12.2775 L1,2.5 C1,1.671875 1.671875,1 2.5,1 L13,1 L13,12 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.60bd6d5e736f4a3f6a06135f34ef8622.svg";
export { ForwardRef as ReactComponent };